import { render } from "./ProsesProduk.vue?vue&type=template&id=878259cc"
import script from "./ProsesProduk.vue?vue&type=script&lang=js"
export * from "./ProsesProduk.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__